import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Header from '../../components/header/Header';
import { checkDefaultTab } from '../../utils/useful';
import Cookies from 'universal-cookie';
import WidgetComponents from '../../components/widgets/WidgetComponents';

class UserPerspectivePageViewer extends Component {

    state = {
        showBackBtn: false,
        showToolbar: false,
        headerConfig: {
            showToolbar: false, showSettings: false, showFrames: 'static'
        },
        info: {
            modules: [
                {
                    id: 'S0PWhvw1oMumKMRwyJxua', children: [
                        {
                            id: 'REXlGiZpqY7S5oIpkHIfb', children: [
                                {
                                    id: 'nAMZvPZ5BG6wfDKIgBZby', type: 'ProgressChart', information: { applet: '6492b30d295845ce7963d616', title: '{{lang}}Progress Chart', min: '0', max: '100' },
                                    parents: [{ id: 'S0PWhvw1oMumKMRwyJxua', type: 'row' }, , { id: 'REXlGiZpqY7S5oIpkHIfb', type: 'column' }]
                                }
                            ], type: 'column', temp: false
                        }
                    ], type: 'row', temp: false
                },
                {
                    id: '2K51GNOopJf46sGNFdzpx', children: [
                        {
                            id: '-kqtsuQCkhdJ7_292Sbkg', children: [
                                {
                                    id: 'JFJCYWXEVQNy0vf-Ubrnv', type: 'UpdatesWidget', information: { title: '{{lang}}Updates', col: '12', type: 'bar', applet: '6492b30d295845ce7963d616' },
                                    parents: [{ id: '2K51GNOopJf46sGNFdzpx', type: 'row' }, { id: '-kqtsuQCkhdJ7_292Sbkg', type: 'column' }]
                                }
                            ], type: 'column', temp: false
                        }
                    ], type: 'row', temp: false
                },
                {
                    id: '3Z9VyVIpVvC5YkEnkRJeP', children: [
                        {
                            id: 'QWshnjMP3YjJK2B7qS5W4', type: 'ChartWidget', information: { applet: '6492b30d295845ce7963d616', title: '{{lang}}Chart', col: '12', type: 'bar' },
                            parents: [{ id: '3Z9VyVIpVvC5YkEnkRJeP', type: 'row' }, { id: 'g1N8eN-dqc0jeP5ufbNH_', type: 'column' }]
                        }
                    ], type: 'row', temp: false
                }
            ]
        },
    }

    componentDidMount() {
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }
        if (this.props.defaultHeaderConfig) {
            this.setState({ headerConfig: this.props.defaultHeaderConfig })
        }
    }

    componentDidUpdate(prevProps) {
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
        if ((JSON.stringify(this.props.frames) != JSON.stringify(prevProps.frames))) {
            let accessPages = this.props.frames
            let accessSections = this.props.framesSections
            this.setState({ modules: accessPages, sections: accessSections, oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                let accessPages = this.props.frames
                let accessSections = this.props.framesSections
                this.setState({ modules: accessPages, sections: accessSections, oldData: this.props.windowData }, () => {
                    this.checkDefaultTab()
                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }

    checkDefaultTab() {
        checkDefaultTab(this.props.windowData, this.props.baseUrl, this.state.modules, this.props.width, (pageInfo, pageType, def) => {
            def = def ?? ''
            pageType = pageType != null ? pageType : def
            if (pageType != null) {
                this.setState({ oldData: this.props.windowData, path: def, pageType: pageType }, () => {
                    setTimeout(() => {
                        this.setState({ page: pageInfo, pageType, headers: pageInfo?.fields ?? pageInfo?.headers, pageStatus: 200 }, () => {
                            if (this.stageManager) {
                                this.stageManager.changeStage((pageType), () => {
                                })
                            }
                        })
                    }, 10);
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        })
    }

    changePage = (page) => {
        let extraPath = Array.isArray(page) ? page : [page]
        let fullPath = [...this.props.baseUrl, ...extraPath]
        this.changeWindow(fullPath)
    }

    functionsHandler = (type, name, data) => {
        if (type) {
            if (this[type] && this[type][name]) {
                this[type][name](data)
            }
        } else {
            if (this[name]) {
                this[name](data)
            }
        }
    }

    showModules = (item) => {
        return (
            item.children && item.children.map((prop) => {
                return (
                    prop.children && prop.children.map((cprop) => {
                        if (cprop?.information) {
                            let information = cprop.information
                            let Component = WidgetComponents[cprop.type];
                            if (Component) {
                                return (
                                    <div className={"col-12 col-md-4 col-lg-4 mb-4"} key={cprop._id ?? cprop.id}>
                                        <div className="dashboard-widgets" style={{}}>
                                            <Component data={cprop} dashboard={this.state.info} />
                                        </div>
                                    </div>
                                );
                            } else { }
                        }
                        else {
                            this.showModules(cprop)
                        }
                    })
                )
            })
        )
    }

    render() {
        return (
            <div className='d-flex w-100 h-100 window-content-radius ' style={{ display: 'block', backgroundColor: '#fff' }}>
                <div className="w-100  h-100  window-content-radius d-flex flex-column " ref={el => this.pageContainer = el} style={{}} >
                    <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                    </div>
                    <div className='p-3 sc-gray4 overflow-auto'>
                        <div className="row m-0">
                            {this.state.info?.modules && this.state.info?.modules.map((prop) => {
                                return (
                                    this.showModules(prop)
                                )
                            })}

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserPerspectivePageViewer);